export const NO_ASK = 0

export function nextAskId(currentAskId: number): number {
    return currentAskId + 1
}

export function askIdAfterClose({
    currentAskId,
    closingAskId,
}: {
    currentAskId: number
    closingAskId: number
}): number {
    return currentAskId === closingAskId ? NO_ASK : currentAskId
}
